import React from 'react';
import { IconLocalShipping } from '@tvg/fuse/icon/all';
import { IconElement } from '@tvg/fuse/icon-element';
import { SkeletonText } from '@tvg/fuse/skeleton';
import styles from './Skeleton.module.css';

export default function Skeleton() {
  return (
    <div className={styles.container}>
      <div className={styles.iconContainer}>
        <IconElement
          icon={<IconLocalShipping />}
          responsiveSize="small"
          dataTestId="delivery-card-icon"
          srLabel="Delivery"
        />
      </div>
      <div className={styles.lines}>
        <SkeletonText
          lineHeight="m2"
          width={{
            s: '90%',
            l: '85%',
          }}
        />
      </div>
    </div>
  );
}
